import { Outlet, createRootRouteWithContext, redirect, useLocation } from "@tanstack/react-router"

import { AuthenticatedAppLayout } from "../components/layout/authenticated-app-layout"
import type { AuthContextType } from "../providers/auth-provider"

type RouterContext = {
  auth: AuthContextType
}

export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: ({ context, location }) => {
    if (location.pathname === "/login") {
      return
    }
    if (!context.auth.user) {
      throw redirect({
        to: "/login",
        search: { redirect: `${location.pathname}${location.searchStr}` },
      })
    }
  },
  component: RootLayout,
})

function RootLayout() {
  const pathname = useLocation({ select: (location) => location.pathname })
  if (pathname === "/login") {
    return <Outlet />
  }
  return (
    <AuthenticatedAppLayout>
      <Outlet />
    </AuthenticatedAppLayout>
  )
}
